// extracted by mini-css-extract-plugin
module.exports = {"progress":"Snackbar_progress__sx-AR"};